module.exports = __webpack_public_path__ + "media/images/icons/ic_arrowdown_24-56a2953d3cd4b4250282750ce29e6a7b.svg";